import { render, staticRenderFns } from "./QuickviewCustomer.vue?vue&type=template&id=1ddaea8a&scoped=true&"
import script from "./QuickviewCustomer.vue?vue&type=script&lang=js&"
export * from "./QuickviewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./QuickviewCustomer.vue?vue&type=style&index=0&id=1ddaea8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddaea8a",
  null
  
)

export default component.exports